import { render, staticRenderFns } from "./tagsNav.vue?vue&type=template&id=7b379e72&scoped=true&"
import script from "./tagsNav.vue?vue&type=script&lang=js&"
export * from "./tagsNav.vue?vue&type=script&lang=js&"
import style0 from "./tagsNav.vue?vue&type=style&index=0&id=7b379e72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b379e72",
  null
  
)

export default component.exports